import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const links = [{
  name: 'Features',
  href: '/features'
}, {
  name: 'Pricing',
  href: '/pricing'
}, {
  name: 'Integration',
  href: '/integration'
}, {
  name: 'About',
  href: '/about'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled || isMobileMenuOpen ? 'bg-sovereign-navy/95 backdrop-blur-md border-b border-white/5 py-4' : 'bg-transparent py-6'}`} data-id="element-117">
      <div className="container mx-auto px-6 max-w-7xl flex items-center justify-between" data-id="element-118">
        <Link to="/" className="relative z-50 group" data-id="element-119">
          <span className="text-2xl font-serif text-white group-hover:text-sovereign-gold transition-colors duration-300" data-id="element-120">
            Sovereign{' '}
            <span className="text-sovereign-gold italic group-hover:text-white transition-colors duration-300" data-id="element-121">
              eTims
            </span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-122">
          {links.map(link => <Link key={link.name} to={link.href} className="text-sm uppercase tracking-widest text-gray-300 hover:text-sovereign-gold transition-colors duration-300 relative group" data-id="element-123">
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-sovereign-gold transition-all duration-300 group-hover:w-full" data-id="element-124" />
            </Link>)}
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white z-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-125">
          {isMobileMenuOpen ? <X data-id="element-126" /> : <Menu data-id="element-127" />}
        </button>

        {/* Mobile Nav */}
        <AnimatePresence data-id="element-128">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute inset-0 min-h-screen bg-sovereign-navy flex flex-col items-center justify-center gap-8 md:hidden" data-id="element-129">
              {links.map(link => <Link key={link.name} to={link.href} className="text-2xl font-serif text-white hover:text-sovereign-gold transition-colors" data-id="element-130">
                  {link.name}
                </Link>)}
            </motion.div>}
        </AnimatePresence>
      </div>
    </nav>;
}